import { __assign } from "tslib";
import React, { useEffect, useMemo, useState } from 'react';
import { capitalize, safeCallback } from '../../../library/helpers';
import classNames from 'classnames';
import styles from './dropdown.module.css';
/**
 * @deprecated replaced by 'DropdownSelect/DropdownMenu/DropdownSearch'
 */
export var Dropdown = React.forwardRef(function (props, ref) {
    var _a, _b, _c;
    var _d = useState(), internalValue = _d[0], setInternalValue = _d[1];
    var _e = props.haserror, hasError = _e === void 0 ? false : _e, _f = props.variant, variant = _f === void 0 ? 'standard' : _f, _g = props.responsive, responsive = _g === void 0 ? false : _g, _h = props.disabled, disabled = _h === void 0 ? false : _h;
    var children = useMemo(function () { return (Array.isArray(props.children) ? props.children : [props.children]); }, [props.children]);
    var longestValue = useMemo(function () {
        if ((children === null || children === void 0 ? void 0 : children.length) > 0) {
            var values = children.map(function (e) { return e.props.children; });
            if (typeof props.label === 'string')
                values.push(props.label);
            return values.reduce(function (a, b) { return ((a === null || a === void 0 ? void 0 : a.length) > (b === null || b === void 0 ? void 0 : b.length) ? a : b); });
        }
        return props.label;
    }, [props.label, children]);
    var cleansedProps = __assign(__assign({}, props), { className: void 0, label: void 0, haserror: void 0, children: void 0, variant: void 0, responsive: void 0, onChange: function (event) {
            var _a;
            safeCallback(props.onChange, event);
            var input = event.target;
            var option = input.selectedOptions[0];
            setInternalValue((_a = option.textContent) !== null && _a !== void 0 ? _a : void 0);
        } });
    useEffect(function () {
        var value = props.value || props.defaultValue;
        var item = children.find(function (c) { return c.props.value === value; });
        if (!!item && item.props.children !== internalValue) {
            setInternalValue(item.props.children);
        }
        else if (typeof value === 'undefined' || value === null)
            setInternalValue(void 0);
    });
    return (React.createElement("div", { className: classNames("inputWrapperDeprecated", styles.dropdownWrapper, (_a = {}, _a[styles.hasError] = hasError, _a[styles.disabled] = disabled, _a[styles.responsive] = responsive, _a), styles["dropdownVariant".concat(capitalize(variant))], "kplr_dropdownWrapper"), tabIndex: -1 },
        React.createElement("select", __assign({}, cleansedProps, { ref: ref, tabIndex: 0 }),
            !props.value && !internalValue && React.createElement("option", { value: "" }, "Select an option..."),
            props.children),
        React.createElement("div", { tabIndex: -1, className: classNames(styles.dropdownValue, (_b = {}, _b[styles.noLabel] = !props.label, _b[styles.hasValue] = !!internalValue, _b)) },
            React.createElement("div", { className: styles.dropdownDisplayValue, tabIndex: -1 }, internalValue),
            !responsive && React.createElement("div", { className: styles.dropdownPhantomValues }, longestValue),
            !!props.label && (React.createElement("label", { className: classNames(styles.dropdownLabel, (_c = {}, _c[styles.disabled] = disabled, _c)), tabIndex: -1 }, props.label)),
            React.createElement("div", { className: styles.dropdownArrow, tabIndex: -1 },
                React.createElement("svg", { tabIndex: -1, fill: "none", viewBox: "0 0 12 8" },
                    React.createElement("path", { tabIndex: -1, fill: "none", d: "m6.50461 7.3892 4.24219-4.11863c.6539-.63487.3525-2.11027-.4349-2.1291L1.68505.93524C.886965.916161.559247 2.40907 1.21873 3.05955l4.38471 4.32487c.2715.2678.62832.26969.90117.00478Z" }))))));
});
Dropdown.displayName = 'Dropdown';
export default Dropdown;
